import React from "react";
import { Box, Button, Typography } from "@mui/material";
import axiosInstance from "src/helpers/context/axiosInstance";
import { URLS } from "src/helpers/constants/url";
import { Formik } from "formik";
import * as Yup from "yup";
import { InputTextField } from "src/view/component/UI/textfield";
import {
  captureException,
  trackActivity,
} from "src/helpers/context/sentry";

const ContactUs = ({ gothe_mile, setContactMessage, setLoader }) => {

    return (
        <>
            <Box id="contact" className="contactus-wrap bg-light-blue sm-title">
                <Box className="main_container">
                    <Typography variant="h2" className="sub-title">{gothe_mile?.home?.contact_us}</Typography>
                    <Box className="form-wrap">
                        <Formik
                            initialValues={{ name: "", email: "", message: "" }}
                            validationSchema={Yup.object().shape({
                                name: Yup.string().trim().required(gothe_mile?.validation?.required_message),
                                email: Yup.string()
                                    .required(gothe_mile?.validation?.enterEmailId)
                                    .email(gothe_mile?.validation?.valid_email),
                                message: Yup.string().trim().required(gothe_mile?.validation?.required_message),
                            })}
                            onSubmit={async (formData, { resetForm }) => {
                                let payload = {
                                    name: formData?.name,
                                    email: formData?.email,
                                    message: formData?.message,
                                    mobile: "",
                                    subject: formData?.message,
                                };
                                setLoader(true);
                                trackActivity("contact.submit.start", {
                                    email: formData?.email,
                                    name: formData?.name,
                                    messageLength: formData?.message?.length,
                                });
                                try {
                                    const { data, status } = await axiosInstance.post(
                                        URLS.contactUsSave,
                                        payload
                                    );
                                    if (status === 200) {
                                        if (data?.value === true) {
                                            setLoader(false);
                                            let contactId = {
                                                _id: data?.data?._id,
                                            };
                                            setLoader(true);
                                            const { status: emailStatus } = await axiosInstance.post(
                                                URLS.contactUsEmail,
                                                contactId
                                            );
                                            if (emailStatus === 200) {
                                                setLoader(false);
                                                trackActivity("contact.submit.success", {
                                                    contactId: data?.data?._id,
                                                    email: formData?.email,
                                                });
                                                setContactMessage(true);
                                                resetForm();
                                            } else {
                                                setLoader(false);
                                                trackActivity(
                                                    "contact.email_failed",
                                                    { contactId: data?.data?._id },
                                                    { level: "warning" }
                                                );
                                                resetForm();
                                            }
                                        } else {
                                            setLoader(false);
                                            trackActivity(
                                                "contact.save_failed",
                                                {
                                                    email: formData?.email,
                                                    message: data?.error?.message,
                                                },
                                                { level: "warning" }
                                            );
                                        }
                                    } else { setLoader(false); }
                                } catch (error) {
                                    captureException(error, {
                                        source: "contact.submit",
                                        tags: { feature: "contact" },
                                        email: formData?.email,
                                    });
                                    setLoader(false);
                                }
                            }}
                        >
                            {({
                                errors, touched, handleBlur, handleChange, handleSubmit, values }) => (
                                <form onSubmit={handleSubmit}>
                                    <label>{gothe_mile?.home?.full_name}*</label>
                                    <InputTextField
                                        fullWidth
                                        type="text"
                                        name="name"
                                        value={values?.name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(touched?.name && errors?.name)}
                                        helperText={touched?.name && errors?.name}
                                        variant="outlined"
                                    />
                                    <label>{gothe_mile?.home?.email}*</label>
                                    <InputTextField
                                        fullWidth
                                        type="email"
                                        name="email"
                                        value={values?.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(touched?.email && errors?.email)}
                                        helperText={touched?.email && errors?.email}
                                        variant="outlined"
                                    />
                                    <label>{gothe_mile?.home?.your_msg}*</label>
                                    <InputTextField
                                        fullWidth
                                        name="message"
                                        multiline
                                        minRows={3}
                                        value={values?.message}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(touched?.message && errors?.message)}
                                        helperText={touched?.message && errors?.message}
                                        variant="outlined"
                                    />
                                    <Button type="submit" variant="blue" className="send_btn">{gothe_mile?.send}</Button>
                                </form>
                            )}
                        </Formik>
                    </Box>
                </Box>
            </Box>
        </>
    )
};
export default React.memo(ContactUs);
